module.exports = __webpack_public_path__ + "img/ac3.ebd95a2b.jpg";